/**
 * Frontend carousel for offbeat/vendor-testimonials.
 *
 * Shows one slide at a time. Prev/next step through with wraparound. Auto-advances
 * every 4 seconds, restarting the timer on manual navigation. No-op when there is a
 * single slide.
 */
function offbeatInitTestimonials( root ) {
	const slides = Array.from( root.querySelectorAll( '.offbeat-testimonial-slide' ) );

	if ( slides.length < 2 ) {
		return;
	}

	const interval = 4000;
	let current = 0;
	let timer = null;

	const show = ( index ) => {
		current = ( index + slides.length ) % slides.length;
		slides.forEach( ( slide, i ) => slide.classList.toggle( 'on', i === current ) );
		root.setAttribute( 'data-current', String( current ) );
	};

	const start = () => {
		timer = window.setInterval( () => show( current + 1 ), interval );
	};

	const restart = () => {
		window.clearInterval( timer );
		start();
	};

	const prev = root.querySelector( '.offbeat-testimonial-prev' );
	const next = root.querySelector( '.offbeat-testimonial-next' );

	if ( prev ) {
		prev.addEventListener( 'click', () => {
			show( current - 1 );
			restart();
		} );
	}
	if ( next ) {
		next.addEventListener( 'click', () => {
			show( current + 1 );
			restart();
		} );
	}

	start();
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.wp-block-offbeat-vendor-testimonials .offbeat-testimonial' )
		.forEach( offbeatInitTestimonials );
} );
